import { isEmpty, throttle } from "lodash-es";
import { computed, ref } from "vue";
import { gameEndApi } from "@/api/game";
import { useAppStore } from "@/store/app";
import { useGameStore } from "@/store/game";
import { useUserStore } from "@/store/user";
import { useSystemStore } from "@/store/system";
import { useTenantStore } from "@/store/tenant";
import { useStatusStore } from "@/store/status";
import { MTpushInterfaceHandler } from "@/logic";
import { useChannelStore } from "@/store/channel";
import { checkPawLaunchButton } from "@/utils/interval";
import { checkTaskReward } from '@/hooks/useTask'
import { CarouselConfigModel } from "@/api/normal/model";
import compulsoryHandle from "@/utils/pwa/compulsory";
import router from "@/router";
import { emitter } from "@/utils/event";
import isShowApkTask from '@/utils/pwa/apkTask'
import closeModal from '@/utils/pwa/closeCompulsoryModal'
import { checkThirdPartyAuth } from "@/hooks/useOAuth";
const swiperKey = ref(0); // 轮播图key
const contentRef = ref(); // 内容DOM
const tabValue = ref(""); // 导航标签动态值
const sticky = ref(false); // 是否固定标签
const sortName = ref([""]); // 游戏分类名称列表
const segmentTop = ref("0"); // 标签定位样式
const segmentHeight = ref(68); // 标签高度
const gameList = ref<any[]>([]); // 游戏列表
const segmentHandle = ref(false); // 是否开启导航标签切换事件
const sortAll = ref<string[]>([]); // 游戏分类列表
const popularList = ref<any[]>([]); // 热门游戏列表
const showAllSort = ref<boolean[]>([]); // 分类是否显示全部
const showBackToTop = ref<boolean>(false); // 是否显示回到顶部按钮
const carouselList = ref<CarouselConfigModel>([]); // 轮播图列表
const marqueeContent = ref<CarouselConfigModel>([]); // 跑马灯内容

export default function useInicioLogic() {
	const appStore = useAppStore();
	const userStore = useUserStore();
	const gameStore = useGameStore();
	const systemStore = useSystemStore();
	const tenantStore = useTenantStore();
	const statusStore = useStatusStore();
	const channelStore = useChannelStore();
	const elementStore = useElementStore();
	const taskStore = useTaskStore()
	const isApp = computed(() => systemStore.isApp); // 是否是APP
	const tabBarHeight = computed(() => elementStore.tabBarHeight); // 底部导航栏高度
	const popularPlatform = computed(() => gameStore.popularPlatform); // 热门游戏平台列表
	const paymentPartnerPic = computed(() => tenantStore.tenantInfo?.paymentPartnerPic); // 支付合作伙伴图片
	const pwaBarVisible = computed(
		() =>
			// 是否显示PWA顶部安装栏
			appStore.isShowPwaBar
	);
	const isShowSportsGames = computed(() => {
		let target = gameStore.homeGames.find((it: any) => it.gameType === "SPORTS");
		if (!target || isEmpty(target?.platformList)) return false;
		return (target?.platformList as any).filter((item: any) => item.target === "hall" && item.hot)?.length > 0;
	});
  const showUnRead = computed(() => {
    const emailTrue = !!userStore.unreadMailCount; // 未读邮件数量
    const announcementTrue = !!userStore.getUnreadAnnouncementCount; // 未读公告数量
    return emailTrue || announcementTrue;
  });

	const segmentRef = ref(); // 分类导航栏DOM
	// 显示的游戏列表
	const showGameList = ref<any[]>([]);

	// 游戏卡片参数
	const gameWrapperOptions = computed(() => {
    const { theme, home, homeType } = tenantStore.themeConfig as Record<string, any>;
    const headTypes: Record<string, any> = {
      'blue-default-GameType': () => ({
        titleType: '2',
        headType: '1',
        size: 6,
        row: 2,
        hotSize: 9,
        hotRow: 3,
      }),
      'blue-default-Platform': () => ({
        titleType: '1',
        headType: '3',
        isShowAll: true,
        size: 12,
        row: 3,
        hotSize: 16,
        hotRow: 4,
      }),
      'blue-default-v01-GameType': () => ({
        titleType: '1',
        headType: '6',
        size: 16,
        row: 4,
        hotSize: 16,
        hotRow: 4,
      }),
      'green-default-v01-GameType': () => ({
        titleType: '1',
        headType: '1',
        size: 12,
        row: 3,
        hotSize: 16,
        hotRow: 4,
      }),
      'green-default-v01-Platform': () => ({
        titleType: '1',
        headType: '4',
        size: 12,
        row: 3,
        hotSize: 16,
        hotRow: 4,
      }),
      'green-default-v02-Platform': () => ({
        titleType: '1',
        headType: '5',
        size: 9,
        row: 3,
        hotSize: 12,
        hotRow: 4,
      }),
    }
    const key = `${theme}-${home ? (home + '-') : ''}${homeType ?? 'GameType'}`;
    const headType = headTypes[key] || headTypes['blue-default-GameType'];
    return headType()
  });

  function showBonusPool(themeKey: string, bonusPoolID: number) {
    const bonusPool: { [key: number]: string[] } = {
      1: ['green-default-v02-Platform', 'blue-default-v01-GameType'],
      2: ['green-default-v01-Platform'],
    };
    return bonusPool[bonusPoolID]?.includes(themeKey) ?? false;
  }

  function forTabValueOptions(item: any) {
    const { size, row, hotRow, hotSize, ...rest } = gameWrapperOptions.value;
    let logoType = "1";
    let currentSize = size;
    let currentRow = row;
    let platformId = String(item.id);
    if (item.gameType === "POPULAR") {
      currentRow = hotRow;
      currentSize = hotSize;
    }
    if (item.hot) {
      logoType = "2";
      platformId = String(item.platformId);
    }
    return {
      ...rest,
      logoType,
      platformId,
      size: currentSize,
      row: currentRow,
      platform: item,
      gameList: item.list,
    }
  }

	// 监听商户ID变化
	watch(
		() => tenantStore.tenantId,
		async () => {
			if (tenantStore.tenantId) {
				const tenantInfo = await tenantStore.resetTenantInfo(); // 重置商户信息
				appStore.setLocale(tenantInfo?.language); // 设置语言
				automatic(); // 重新批量获取数据
			}
		},
	);

	// 监听路由变化
	watch(
		() => router.currentRoute.value.path,
		(patch) => {
			if (patch === "/main/inicio") {
				if (!appStore.token) {
					userStore.clearFavoriteList(); // 清空收藏列表
					userStore.unreadMailCount = 0; // 未读邮件数量
					userStore.announcementList = []; // 未读公告数量
					checkShowLogin();

				} else {
					userStore.setAssets(); // 获取用户资产
				}
				automatic();
				swiperKey.value++;
			}
		},
	);

	// 监听token变化
	watch(
		() => appStore.token,
		(token) => {
			if (token) {
				automatic(); // 重新批量获取数据
			}
		},
	);

	watch(
		() => userStore.user?.id,
		(userId) => {
			if (!userId) return;
			useGetFavoriteGame(); // 获取收藏列表的游戏
		},
	);

	// 检测是否需要显示登录注册弹窗
	function checkShowLogin() {
		nextTick(async () => {
			if (statusStore.redirectRoute === "register") await showLogin("register");
			else if (statusStore.redirectRoute === "login") await showLogin("login");

			statusStore.setRedirectRoute('')
		});
	}
	const showPwaFooter = () => {
		appStore.setPwaFooterVisible(true); // 设置PWA底部栏显
		appStore.isShowPwaFooter = true;; // 设置PWA底部栏显
		appStore.alreadyPwaFooter = true;
	}

	// 生命周期-挂载前
	onBeforeMount(() => {
		automatic(); // 重新批量获取数据
	});

	const compulsoryHandleTodo = async () => {
		if (statusStore.isRegisterPage) {
			const isShowCompulsoryModal = await compulsoryHandle()
			statusStore.isRegisterPage = false
			//  已经显示pwa强制弹框没有必要显示pwa底部弹框
			if (!isShowCompulsoryModal) {
				showPwaFooter()
			}
		}

	}
	const isShowAPKModal = async () => {
		await taskStore.updateTaskList('NewbieTask');
		const isSHowTaskModal = await taskStore.checkShowRookieTaskModal()
		if (!isSHowTaskModal) return false
		return await isShowApkTask()
	};
	const updateAssetsShowAPKModal = async () => {
		await userStore.setUser()
		isShowAPKModal()
	}

	// 生命周期-挂载后
	onMounted(() => {
		checkShowLogin();
		checkThirdPartyAuth();
		emitter.on("user/registerModalClose", compulsoryHandleTodo);
		emitter.on("user/login", isShowAPKModal);
		emitter.on("user/pay-success", updateAssetsShowAPKModal);
		emitter.on("user/withdraw-success", updateAssetsShowAPKModal);

	});
	
	onBeforeUnmount(() => {
		emitter.off("user/registerModalClose", compulsoryHandleTodo);
		emitter.off("user/login", isShowAPKModal);
		emitter.off("user/pay-success", updateAssetsShowAPKModal);
		emitter.off("user/withdraw-success", updateAssetsShowAPKModal);

	})

	// 监听内容滚动, 显示隐藏回到顶部按钮
	function watchBuoy({ entry, direction, index, tabKey }: any) {
		if (index > 2) {
			showBackToTop.value = true;
		} else {
			showBackToTop.value = false;
		}
		if (entry.isIntersecting) {
			const voiceBug = segmentRef.value?.voiceBug;
			if (voiceBug) {
				// 纵向滚动segment和游戏卡片左右布局时使用这个方法
				voiceBug(entry, direction, index, tabKey)
			}
		}
	}
	const stickySegmentBottom = ref(0);
	function getGameCardBottom() {
		// 当segment和游戏卡片左右布局时使用这个方法
		const contentEl = document.querySelector('.main-content>.order-container') as Element | null;
		const gameCardEl = document.querySelector('.game-c') as HTMLElement | null;

		if (contentEl && gameCardEl) {
			const { offsetTop = 0, offsetHeight = 0 } = gameCardEl;
			const bottom = contentEl.scrollHeight - offsetTop - offsetHeight;
			if (bottom !== stickySegmentBottom.value) {
				stickySegmentBottom.value = bottom;
			}
		}
	}
	/**
	 * @description 页面滚动监听
	 */
	function handleContentScroll() {
		// 判断分类导航栏元素是否在视口顶部
		const stickyElement = document.getElementById("stickyElement");
		const rect = stickyElement?.getBoundingClientRect();
		getGameCardBottom();
		if (rect) {
			if (pwaBarVisible.value && rect.top <= 99) {
				sticky.value = true;
			} else if (!pwaBarVisible.value && rect.top <= 49) {
				sticky.value = true;
			} else {
				sticky.value = false;
			}
		}
	}

	/**
	 * @description 导航标签切换事件
	 * @param event 事件对象
	 */
	function tabChange(event: any) {
		segmentHandle.value = true; // 开启导航标签切换事件
		const childSpan = contentRef.value.$el.querySelector(`.${event.detail.value}`); // 获取目标元素DOM
		setTimeout(() => {
			tabValue.value = "";
		}, 300);
	}

	function tabChange1({ filterGameList }: { filterGameList: any[] }) {
		showBackToTop.value = false;
		if (filterGameList) {
			showGameList.value = filterGameList;
		}
	}
	/**
	 * @description 滚动到顶部事件
	 */
	function topHandle() {
		contentRef.value.$el.scrollToTop(500);
	}

	/**
	 * @description 去客服中心
	 */
	function goToCustomer() {
		router.push("/notification");
	}

	/**
	 * @description 触摸开始事件
	 */
	function touchStartHandle() {
		segmentHandle.value = false; // 关闭导航标签切换事件
	}

	/**
	 * @description 跳转游戏搜索页
	 */
	async function navigateToSearch() {
		router.push({ path: "/game/search" });
	}

	/**
	 * @description 自动运行方法
	 */
	const automatic = throttle(
		async () => {

			channelStore.setModalChecked(); // 设置模态框未检查(开启公告弹窗检测)
			await Promise.all([
				onCarouselConfig(), // 获取首页轮播数据
				onGetPopular(), // 获取热门游戏
				onGetGameList(), // 获取首页游戏列表
				tenantStore.getAnnouncementList(), // 获取弹窗公告列表
			]);

			if (userStore.user?.userId && localStorage.getItem("enteredGame") === "true") {
				gameEndApi(userStore.user.userId).then(() => {
					localStorage.removeItem("enteredGame");
				});
			}
			const isLogin = await useAppStore().checkUserHasLogin();
			if (isLogin) {
				channelStore.isShowCompulsoryModal = await isShowAPKModal()
				checkTaskReward(); // 检查当前是否有可领取任务奖励
			}
			// 不顶层窗口不初始化推送
			!router.currentRoute.value.query?.unTopWindow && MTpushInterfaceHandler(); // 初始化推送(极光推送)
			appStore.setDrawerLoad(true); // 设置加载抽屉菜单
			await checkPawLaunchButton(); // 检查PWA启动按钮
			if (!channelStore.isShowCompulsoryModal) {
				channelStore.isShowCompulsoryModal = await compulsoryHandle(); // 检查强制状态
			}

			appStore.setPwaBarVisible(true); // 获取PWA栏是否显示
			appStore.isShowPwaBar = true; // 获取PWA栏是否显示
			//  已经显示pwa强制弹框没有必要显示pwa底部弹框
			if (!channelStore.isShowCompulsoryModal && !appStore.alreadyPwaFooter) {
				showPwaFooter()
			}

			channelStore.setModalChecked(true); // 设置模态框已检查(开启公告弹窗检测)
		},
		500,
		{ leading: true, trailing: false },
	);

	return {
		showBonusPool,
		segmentRef,
		forTabValueOptions,
		showGameList,
		stickySegmentBottom,
		tabChange1,
		watchBuoy,
		gameStore,
		swiperKey,
		isApp,
		sticky,
		tabValue,
		pwaBarVisible,
		segmentHeight,
		segmentTop,
		popularPlatform,
		showBackToTop,
		showUnRead,
		contentRef,
		tabBarHeight,
		paymentPartnerPic,
		automatic,
		isShowSportsGames,
		handleContentScroll,
		tabChange,
		touchStartHandle,
		topHandle,
		goToCustomer,
		navigateToSearch,
	};
}

/**
 * 调用网络接口: 获取热门游戏
 */
async function onGetPopular() {
	const gameStore = useGameStore();
	popularList.value = (await gameStore.requestPopularGames()) || [];
}

/**
 * 调用网络接口: 获取首页游戏列表
 */
async function onGetGameList() {
	const gameStore = useGameStore();

	gameList.value = (await gameStore.requestHomeGames()) || [];
	sortName.value = [];
	showAllSort.value = [];
	gameList.value.forEach((item: any) => {
		setFavorite(item.platformList, item.gameType);
		sortName.value.push(item.gameType);
		showAllSort.value.push(false);
	});
	sortAll.value = ["POPULAR"];
	sortAll.value.push(...sortName.value, "FAVORITE");
}

/**
 * 调用网络接口: 获取首页轮播数据(轮播图+跑马灯)
 */
async function onCarouselConfig() {
	const tenantStore = useTenantStore();
	carouselList.value = await tenantStore.requestCarouselList();
	marqueeContent.value = await tenantStore.requestMarqueeList("text");
}
